// extracted by mini-css-extract-plugin
export default {"table":"devextreme-helper_table__obHZB","stickyRow":"devextreme-helper_stickyRow__Fugoh"};